import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_VARIANT_GROUP } from '../../shapes'
import { withTranslation } from 'react-i18next'
import Checkbox from '../../../Form/Checkbox'
import './styles.scss'
import Alert from '../../../Alert'
import { environment } from '../../../../../environment'

class VariantSelect extends PureComponent {

  state = {
    selectedVariantsMap: {}
  }

  componentDidMount () {
    this.updateSelectedVariantsMap()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedVariants !== this.props.selectedVariants) {
      this.updateSelectedVariantsMap()
    }
  }

  onCollapseToggle = () => {
    this.props.onCollapseChange(!this.props.collapsed)
  }

  applyToAll = () => {
    this.props.onSelectedVariantsChange([])
    this.onCollapseToggle()
  }

  updateSelectedVariantsMap () {
    const selectedVariantsMap = Object.assign({},
      ...this.props.selectedVariants.map((variantId) => ({ [variantId]: true }))
    )
    this.setState({ selectedVariantsMap })
  }

  onCheckboxChange (e, variantId) {
    let newSelectedVariants
    if (e.target.checked) {
      newSelectedVariants = [...this.props.selectedVariants]
      if (newSelectedVariants.indexOf(variantId) === -1) {
        newSelectedVariants.push(variantId)
      }
    } else {
      newSelectedVariants = this.props.selectedVariants.filter(
        (selectedVariantId) => selectedVariantId !== variantId
      )
    }
    this.props.onSelectedVariantsChange(newSelectedVariants)
  }

  render () {
    const { t } = this.props

    if (this.props.collapsed) {
      if (this.props.selectedVariants.length === 0) {
        return <div className={'variant-select'}>
          <div className={'variant-select-header'}>
            <span>{t('APPLY_TO_ALL')}</span>
            <span onClick={this.onCollapseToggle} className={'Link'}>{t('EDIT')}</span>
          </div>
        </div>
      } else {
        let appliesOnlyTo = []
        this.props.variantGroups[0].variants.forEach((variant) => {
          if (this.state.selectedVariantsMap.hasOwnProperty(variant.variantId)) {
            appliesOnlyTo.push('"' + variant.label + '"')
          }
        })
        return <div className={'variant-select'}>
          <div className={'variant-select-header'}>
            <span>{t('APPLY_ONLY_TO')}: {appliesOnlyTo.join(', ')}</span>
            <span onClick={this.onCollapseToggle} className={'Link'}>{t('EDIT')}</span>
          </div>
        </div>
      }
    }
    return (
      <div className={'variant-select'}>
        <div className={'variant-select-header'}>
          <div><span onClick={this.applyToAll} className={'Link'}>{t('APPLY_TO_ALL')}</span></div>
          <span>{t('APPLY_ONLY_TO')}</span></div>
        <div className={'variant-select-options'}>
          {
            this.props.variantGroups[0].variants.length > 0 ?
              this.props.variantGroups[0].variants.map((variant, index) => {
                const keyUsed = variant && variant.variantId ? variant.variantId : `variant:${index}`
                if (environment.IS_DEV && window.__LOG_FS_KEYS) {
                  if (!variant || !variant.variantId) {
                    console.warn('Factsheet key fallback used in VariantSelect option', {
                      index,
                      variant
                    })
                  }
                  console.debug('Factsheet key used (VariantSelect option):', keyUsed)
                }
                return <div key={keyUsed} className={'variant-select-option'}>
                  <Checkbox
                    kind="secondary"
                    onChange={(e) => {
                      this.onCheckboxChange(e, variant.variantId)
                    }}
                    value={this.state.selectedVariantsMap.hasOwnProperty(variant.variantId)}
                    label={variant.label}/>
                </div>
              })
              : <Alert type={'info'}>{t('VARIANT_SELECT_NO_OPTIONS_AVAILABLE')}</Alert>
          }
        </div>
        <div className={'variant-select-footer'}>
          <span onClick={this.onCollapseToggle} className={'Link'}>{t('HIDE_SELECTION')}</span>
        </div>
      </div>
    )

  }
}

VariantSelect.defaultProps = {
  selectedVariants: []
}
VariantSelect.propTypes = {
  onSelectedVariantsChange: PropTypes.func.isRequired,
  onCollapseChange: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  variantGroups: PropTypes.arrayOf(PropTypes.shape(SHAPE_VARIANT_GROUP)).isRequired,
  selectedVariants: PropTypes.arrayOf(PropTypes.string),
}
export default withTranslation()(VariantSelect)
